import type { SolicitarCotacaoDialogProps } from "./types-solicitar-cotacao-dialog";
import { useSolicitarCotacaoDialog } from "./use-solicitar-cotacao-dialog";
import { SolicitarCotacaoDialogView } from "./view-solicitar-cotacao-dialog";

export function SolicitarCotacaoDialog(props: SolicitarCotacaoDialogProps) {
  const vm = useSolicitarCotacaoDialog(props);

  return <SolicitarCotacaoDialogView {...vm} />;
}

export type * from "./types-solicitar-cotacao-dialog";
